import { Injectable } from '@angular/core';
import { Attributes, FormState } from '../../model/form/form-properties/form-state';
import { FormBase } from '../../model/form/form';
import { AsdBase } from '../../model/asd/asd';
import { ASDTypes } from '../../model/asd/asd-properties/asd-type';
import { Header } from '../../model/asd/asd-properties/asd-header';
import { FormInit } from '../../model/form/form-properties/form-init';
import { Attribute } from '../../model/asd/asd-properties/asd-attribute';
import { InterfaceElement, IEValue, IELabel, IEDisplayProperties, IEEntityList } from '../../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { InterfaceElementTypes } from '../../model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { InterfaceElementTemplate } from '../../model/interfaceElement/interfaceElement-properties/interfaceElement-template';
import { IEKeyDictionary } from '../../model/interfaceElement/interfaceElement';
import { IEUserAction } from '../../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { ViewArea } from '../../model/asd/asd-properties/asd-viewArea';
import { RowItem, HeaderItem } from '../../model/asd/asd-properties/asd-ie-type/asd-list';
import { Message, ButtonTextDetails } from '../../model/asd/asd-properties/asd-message';
import { AccessDuty, AccessParameter } from 'src/app/model/access/access-properties/access-duty';
import { CosyFormGroupValidationService } from '../validator/cosy-form-group-validation.service';

import merge  from 'lodash-es/merge';

@Injectable()
export class CosyAppStateDataControllerService {
  constructor(
    private cosyFormGroupValidationService: CosyFormGroupValidationService
  ) { }

  
  private formMessages: any[] = [];
  public currentFormState;
  public resultsFromNestedObjects: any[] = [];

  accessNestedObjects = (object, key, task, accessParams : AccessParameter) => {
    
    if (Array.isArray(object)) {
      for (const nObj of object) {
        switch (task) {

          case AccessDuty.UpdateIE :
                let uie: InterfaceElement = nObj;
                uie = this.updateAdditionalAttributesOfIE(uie, accessParams);
                if(uie.TypeDID == InterfaceElementTypes.FormEntity){
                  this.updateIEPerFormState(uie, accessParams.FormState);
                }
                if(uie.TypeDID == InterfaceElementTypes.Wizard){
                  this.updateIEPerFormState(uie, accessParams.FormState);
                  let groups: InterfaceElement[] = uie.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Groups).InterfaceElements;
                  for (let wie of groups) { 
                    if (wie.InterfaceElements == null) wie.InterfaceElements = [];
                    for (let iee of uie.InterfaceElements) {
                     if ( iee.Attributes.GroupID != null 
                      && wie.InterfaceElementID == iee.Attributes.GroupID && wie.InterfaceElementID != iee.InterfaceElementID) {
                        wie.InterfaceElements.push(iee);
                      }
                    }
                    for (let toRemove_ie of wie.InterfaceElements) {
                      toRemove_ie = this.setDisplayPropsOfIE(toRemove_ie,uie.TypeDID);
                      uie.InterfaceElements.splice(uie.InterfaceElements.indexOf(toRemove_ie), 1);
                    }
                    wie.InterfaceElements.sort((a, b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
                  }                  
                }
                break;


          case AccessDuty.RefreshIE :
                let hie: InterfaceElement = nObj;
                if (hie.TemplateID == accessParams.TemplateID) {
                  this.resultsFromNestedObjects.push(hie);
                }
                break;
          default:
                console.log('Default Access to Nested Objects');
        }
        if(nObj[key]!== null){
            this.accessNestedObjects(nObj[key], key, task, accessParams);
        }
      }
    }
    return this.resultsFromNestedObjects;
  }

  /*Update or Modify UI required objects of Interface Elements*/
  updateUIObjectsOfIE(interfaceElements: InterfaceElement[], uxControllerProps: FormBase, initialized: boolean, dd: AsdBase) {
    
    let accessParameter = new AccessParameter();
    
    if (dd != null) {
       accessParameter.DesignDocumentIEList = dd.InterfaceElements;
    }
   
    if (uxControllerProps != null) {
      accessParameter.FormState = this.getFormState(uxControllerProps);
    }

    this.currentFormState = accessParameter.FormState;
    this.formMessages = uxControllerProps.FormMessages;
    
    this.accessNestedObjects(interfaceElements, 'InterfaceElements', AccessDuty.UpdateIE, accessParameter);

    return interfaceElements;
  
  }

 
  updateAdditionalAttributesOfIE(asdEntity: InterfaceElement, accessParams : AccessParameter) {
   
    asdEntity = this.setDesignParameters(asdEntity, accessParams.DesignDocumentIEList);
    if( (asdEntity.TypeDID == InterfaceElementTypes.FormEntity || 
                                          asdEntity.TypeDID == InterfaceElementTypes.Wizard ||
                                          asdEntity.TypeDID == InterfaceElementTypes.Group ||
                                          asdEntity.TypeDID == InterfaceElementTypes.ListUXController||
                                          asdEntity.TypeDID == InterfaceElementTypes.ListSubUXController||
                                          asdEntity.TypeDID == InterfaceElementTypes.UXController ||
                                          asdEntity.TypeDID == InterfaceElementTypes.EntityList)){                       
        
         
        asdEntity = this.setDisplayPropsOfIE(asdEntity, asdEntity.TypeDID);
        if(asdEntity.InterfaceElements!= null && asdEntity.InterfaceElements.length>0){
            for(let ie of asdEntity.InterfaceElements){
               ie = this.setDesignParameters(ie, accessParams.DesignDocumentIEList);
               ie = this.setDisplayPropsOfIE(ie, asdEntity.TypeDID);
                if (ie.Attributes.Visible || 
                    (ie.CustomizeOptions != null && ie.CustomizeOptions.Display)){
                      ie.Messages = this.formMessages;
                    }
                if(ie.InterfaceElements!= null){
                  this.updateAdditionalAttributesOfIE(ie, accessParams);
                }
          }
          asdEntity.InterfaceElementGroup = this.cosyFormGroupValidationService.toFormGroup(asdEntity);
        } else if(asdEntity.TypeDID == InterfaceElementTypes.EntityList){
           asdEntity.Messages = this.formMessages;
        }
        
    } else {
      asdEntity.Messages = this.formMessages; 
    }
  
    return asdEntity;
  }

  /*Update Form IE according to changed Form Control State after each transition*/
  updateIEPerFormState(interfaceElement: InterfaceElement, formState: FormState) {

    if(formState!= null){
      for (let ieElement of interfaceElement.InterfaceElements) {
        if (interfaceElement.InterfaceElementGroup.controls[ieElement.InterfaceElementID + '_null'] != null) {
          if (ieElement.Attributes.Enabled && !interfaceElement.InterfaceElementGroup.controls[ieElement.InterfaceElementID + '_null'].value) {
            interfaceElement.InterfaceElementGroup.controls[ieElement.InterfaceElementID].enable();
          }
        }
        else {
          if (ieElement.Attributes.Enabled && ieElement.Attributes.Visible) {
            interfaceElement.InterfaceElementGroup.controls[ieElement.InterfaceElementID].enable();
          }
        }
      }
      for (let action of formState.actions) {
        if ((action.fCID === interfaceElement.TemplateID || action.fCID == interfaceElement.InterfaceElementID) && !action.attributes.enabled) {
          interfaceElement.InterfaceElementGroup.disable();
        }
      }

    }
  }

  /*For Customized Purpose, IE are accompanied with keys (InterfaceElementID) */
  getKeyedInterfaceElements(interfaceElements: InterfaceElement[]) {
    let ie = {} as IEKeyDictionary;
    for (let eie of interfaceElements) {
      ie[eie.InterfaceElementID] = eie;
    }
    return ie;
  }

  processPayLoadData(asd: AsdBase, payloadInterfaceElements: InterfaceElement[], multiSelect: boolean) {
    for (let pie of payloadInterfaceElements) {
      asd = this.updateAppStateDocument(asd, pie, true, multiSelect);
    }
    return asd;
  }

  preparePayLoadData(interfaceElementID: string, value: any, key: any, additionalAttributes: any[]) {
    let interfaceElement: InterfaceElement = new InterfaceElement();
    let ieValue: IEValue = new IEValue();
    let ieValues: IEValue[] = [];
    let ieAttribute: Attribute = new Attribute();
    interfaceElement.InterfaceElementID = interfaceElementID;
    interfaceElement.Attributes = ieAttribute;
 
    if (key != null) {
      ieAttribute[key] = value;
      interfaceElement.Attributes = ieAttribute;
    } else {
      if (value != null && typeof value == 'object') {        
        value.forEach(element => {
          ieValue = new IEValue();
          ieValue.Value = element;
          /*if(typeof(element) == 'object' && 'nil' in element){
            ieValue.nil = element['nil']
          }
          if( typeof(element) == 'string'){
            ieValue.Value = element;
          }*/
          ieValues.push(ieValue);
        });
      }
      else if (typeof value != 'number' && typeof value != 'boolean' && value != null && value.indexOf('nil') >= 0) {
        if (value == 'niltrue') ieValue.nil = true;
        else {
          ieValue.nil = false;
          ieValue.Value = '';
        }
        ieValues.push(ieValue);
      }
      else {
        ieValue.Value = value;
        ieValues.push(ieValue);
      }
      interfaceElement.Values = ieValues;
    }

    if (additionalAttributes != null && additionalAttributes.length > 0) {
      for (let a of additionalAttributes) {
        ieAttribute[a['attribute']] = a['value'];
        interfaceElement.Attributes = ieAttribute;
      }
    }
    return interfaceElement;
  }

 
  updateAppStateDocument(asd: AsdBase, interfaceElement: InterfaceElement, processPayLoadFromServer: boolean, multiSelect: boolean) {
    let viewArea: ViewArea;
    if (asd != null) {
      for (viewArea of asd.ViewAreas) {
        viewArea.InterfaceElements = this.updateInterfaceElements(viewArea.InterfaceElements, interfaceElement, processPayLoadFromServer, multiSelect);
        for (let ie of viewArea.InterfaceElements) {
          if(ie.TypeDID == InterfaceElementTypes.Wizard){
            let groups = ie.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Groups).InterfaceElements;
            for(let gie of groups){
              if(gie.InterfaceElements!= null){
                gie.InterfaceElements =  this.updateInterfaceElements(gie.InterfaceElements, interfaceElement, processPayLoadFromServer, multiSelect);
              }
            }
          }
          if (ie.InterfaceElements != null) {
            ie.InterfaceElements = this.updateInterfaceElements(ie.InterfaceElements, interfaceElement, processPayLoadFromServer, multiSelect);
          }
        }
      }
    }
    return asd;
  }

  updateInterfaceElements(viewAreaInterfaceElements: InterfaceElement[], fromUpdateInterfaceElement: InterfaceElement, processPayLoadFromServer: boolean, multiSelect: boolean) {
    for (let vie of viewAreaInterfaceElements) {
      if (vie.InterfaceElementID == fromUpdateInterfaceElement.InterfaceElementID) {
        fromUpdateInterfaceElement.ObjectID = vie.ObjectID;
        fromUpdateInterfaceElement.ObjectName = vie.ObjectName;
        this.mergeInterfaceElementProperties(vie, fromUpdateInterfaceElement, multiSelect);
        this.overwriteInterfaceElementProperties(vie, fromUpdateInterfaceElement);
      }
    }
    return viewAreaInterfaceElements;
  }

  mergeInterfaceElementProperties(toInterfaceElement: InterfaceElement, fromInterfaceElement: InterfaceElement, multiSelect: boolean) {
    merge(toInterfaceElement.Attributes, fromInterfaceElement.Attributes);
    if(toInterfaceElement.Values!=null){     
      if (multiSelect == null || !multiSelect ) {
        let valuesCount = toInterfaceElement.Values.length;
        if (valuesCount > 1) toInterfaceElement.Values.splice(1, valuesCount - 1);
        if (fromInterfaceElement.Values!= null) toInterfaceElement.Values = fromInterfaceElement.Values;
       // toInterfaceElement.Values = fromInterfaceElement.Values;
          //_.merge(toInterfaceElement.Values, fromInterfaceElement.Values);
      }
      else  toInterfaceElement.Values.push(fromInterfaceElement.Values[0])
        merge(toInterfaceElement.PreLabel, fromInterfaceElement.PreLabel);
    }
  }

  overwriteInterfaceElementProperties(toInterfaceElement: InterfaceElement, fromInterfaceElement: InterfaceElement) {
    if (toInterfaceElement.TypeDID == InterfaceElementTypes.InputPicklist) {
      if (fromInterfaceElement.DynamicMetaData != null && toInterfaceElement.DynamicMetaData != null) {
        toInterfaceElement.DynamicMetaData.Items = fromInterfaceElement.DynamicMetaData.Items;
      }
    } else if (toInterfaceElement.TypeDID == InterfaceElementTypes.EntityList) {
      if (fromInterfaceElement.EntityList != null && toInterfaceElement.EntityList != null) {
        toInterfaceElement.EntityList.RowItems = fromInterfaceElement.EntityList.RowItems;
      }
      if (fromInterfaceElement.Filters != null && toInterfaceElement.Filters != null) {
        toInterfaceElement.Filters = fromInterfaceElement.Filters;
      }
    }
  }

  prepareCustomASD(asdFromAPI: AsdBase) {
    let customASD: AsdBase = new AsdBase();
    let headerCustomASD: Header = new Header();
    let interfaceElement: InterfaceElement = new InterfaceElement();
    let interfaceElements: InterfaceElement[] = [];

    let rowItems: RowItem[] = [];
    let headerItems: HeaderItem[] = [];
    headerCustomASD.DocType = 'CustomAppStateDocument';
    headerCustomASD.AppStateID = asdFromAPI.Header.AppStateID;
    headerCustomASD.SessionID = asdFromAPI.Header.SessionID;
    headerCustomASD.Version = asdFromAPI.Header.Version;

    customASD.Header = headerCustomASD;
    customASD.InterfaceElements = interfaceElements;

    return customASD;
  }


  processHistoryRefresh(form: FormInit) {
    let refreshObj = { userActionID: '', interfaceElementID: '' };
    let rObjList;
    let accessParameter = new AccessParameter();
    if (form.Header.ViewTypeDID == ASDTypes.ListViewTypeDID) {
      accessParameter.TemplateID = InterfaceElementTemplate.ListViewRefreshTemplateID;
      for (let va of form.ViewAreaList) {
        rObjList = this.accessNestedObjects(va.InterfaceElements, 'InterfaceElements', AccessDuty.RefreshIE, accessParameter);
        if(rObjList.length > 0){
          refreshObj.interfaceElementID = rObjList[0].InterfaceElementID;
          refreshObj.userActionID = rObjList[0].UserActions[0].UserActionID;
        }
        this.resultsFromNestedObjects = [];
      }
    } else if (form.Header.ViewTypeDID == ASDTypes.EntityViewTypeDID || form.Header.ViewTypeDID == ASDTypes.WizardViewTypeDID) {
      accessParameter.TemplateID = InterfaceElementTemplate.EntityViewRefreshTemplateID;
      for (let va of form.ViewAreaList) {
        rObjList = this.accessNestedObjects(va.InterfaceElements, 'InterfaceElements', AccessDuty.RefreshIE, accessParameter);
        if(rObjList.length > 0){
          refreshObj.interfaceElementID = rObjList[0].InterfaceElementID;
          refreshObj.userActionID = rObjList[0].UserActions[0].UserActionID;
        }
        this.resultsFromNestedObjects = [];
      }
    }
    return refreshObj;
  }

  preparePayLoadASD(asdFromAPI: AsdBase, payLoadIEs: InterfaceElement[], multiSeclect: boolean) {
    let payLoadOfASD: AsdBase = new AsdBase();
    let headerPayLoadOfASD: Header = new Header();

    if (asdFromAPI != null) {
      headerPayLoadOfASD.DocType = 'PayloadAppStateDocument';
      headerPayLoadOfASD.AppStateID = asdFromAPI.Header.AppStateID;
      headerPayLoadOfASD.SessionID = asdFromAPI.Header.SessionID;
      headerPayLoadOfASD.Version = asdFromAPI.Header.Version;
      payLoadOfASD.Header = headerPayLoadOfASD;
    }

    var duplicates: InterfaceElement[] = payLoadIEs.filter(i => payLoadIEs.filter(ii => ii.InterfaceElementID === i.InterfaceElementID).length > 1);

    if (duplicates.length == 2) {
      this.mergeInterfaceElementProperties(duplicates[0], duplicates[1], multiSeclect);
      let dupleIndex = payLoadIEs.indexOf(duplicates[1]);
      payLoadIEs.splice(dupleIndex, 1);
      duplicates = [];
    }

    payLoadOfASD.InterfaceElements = payLoadIEs;
    
    return payLoadOfASD;
  }

  getDocType(document: any) {
    let cosyDoc: AsdBase;
    let docType: string;

    cosyDoc = document['CosyDocument'];

    if (cosyDoc == null || cosyDoc.Header == null || cosyDoc.Header.DocType == null) docType = null;
    else if (cosyDoc.Header.DocType == ASDTypes.ASD) {
      docType = ASDTypes.ASD;
    } else if (cosyDoc.Header.DocType == ASDTypes.CASD) {
      docType = ASDTypes.CASD;
    } else if (cosyDoc.Header.DocType == ASDTypes.DD) {
      docType = ASDTypes.DD;
    } else if (cosyDoc.Header.DocType == ASDTypes.PASD) {
      docType = ASDTypes.PASD;
    } else if (cosyDoc.Header.DocType == ASDTypes.TASD) {
      docType = ASDTypes.TASD;
    } else if (cosyDoc.Header.DocType == 'MessagesDocument') {
      docType = 'MessagesDocument';
    } else if (cosyDoc.Header.DocType == 'Error') {
      docType = 'Error';
    } else {
      docType = null;
    }
    return docType;
  }

  isActionProcessOnServer(userActionID: string, userActions: IEUserAction[]) {
    let actionProcessOnServer: boolean = false;
    if (userActions != null && userActions.length > 0) {
      for (let ua of userActions) {
        if (ua.UserActionID == userActionID && ua.ActionProcessOnServer) {
          actionProcessOnServer = true;
        }
      }
    }

    return actionProcessOnServer;
  }

  getFormState(uxControllerProps: FormBase) {
    let formState: FormState = null;
    if (Object.keys(uxControllerProps).length > 0 && uxControllerProps.FormStates != null) {
      for (let state of uxControllerProps.FormStates) {
        if (state.stateID === uxControllerProps.FormCurrentState) {
          formState = state;
        }
      }
    }

    return formState;
  }

  setDesignParameters(asdIE: InterfaceElement, ddIEList: InterfaceElement[]) {
    
    if (ddIEList != null && ddIEList.length > 0) {
      for (let d of ddIEList) {
        if (d.InterfaceElementID == asdIE.InterfaceElementID) {
          Object.assign(asdIE, asdIE, d);
          break;
        }
      }
    }

    return asdIE;
  }

  setDesignParamsInIEList(asdInterfaceElement: InterfaceElement, designIEList: InterfaceElement[]) {
   
    if (asdInterfaceElement.Attributes.Visible) {
      for(let iee of asdInterfaceElement.InterfaceElements){
          iee = this.setDesignParameters(iee, designIEList);
      }
    }
    return asdInterfaceElement;
  }

  setDisplayPropsOfIE(ie: InterfaceElement, parentTypeDID: string){
    /*if(ie.InterfaceElementID == '2a431d06-4f05-4b17-b33c-9569eca50131'){
      console.log('Display Property IE 12333: ', ie);
    }*/
    ie.DisplayProperties = new IEDisplayProperties();
    ie.DisplayProperties.IsDisplayOnUI = true;
    if(ie.PreLabel!=null){
      ie.DisplayProperties.DisplayName = ie.PreLabel.DisplayName;
      ie.DisplayProperties.DisplaySrcKey = "PreLabel";
    } else if(ie.Label!=null){
      ie.DisplayProperties.DisplayName = ie.Label.DisplayName;
      ie.DisplayProperties.DisplaySrcKey = "Label"
    } else if(ie.Name!=null){
      ie.DisplayProperties.DisplayName = ie.Name;
      ie.DisplayProperties.DisplaySrcKey = "Name";
    } else {
      ie.DisplayProperties.DisplayName = "No Display-Name"
    }
    
    if(ie.TypeDID == InterfaceElementTypes.Trigger && 
        (parentTypeDID == InterfaceElementTypes.FormEntity|| parentTypeDID == InterfaceElementTypes.Wizard)) {
         ie.DisplayProperties.IsDisplayOnUI = false;
    }

    return ie;
  }

  prepareLockedMessage(lockedMessage: Message) {
    if (lockedMessage.showText != null) {
      lockedMessage.showButtonText = [];
      let buttonTextDetails: ButtonTextDetails = new ButtonTextDetails();
      buttonTextDetails.environment = lockedMessage.environment;
      if (lockedMessage.showTitle == '' || lockedMessage.showTitle == null) lockedMessage.showTitle = 'Meldung';
      if (lockedMessage.messageType == 0 || lockedMessage.messageType == 7) {
        buttonTextDetails.buttonMessageType = lockedMessage.messageType;
        buttonTextDetails.buttonText = 'Ok';
        buttonTextDetails.answerCode = 0;
        lockedMessage.showButtonText.push(buttonTextDetails);
      } else if (lockedMessage.messageType == 2) {
        buttonTextDetails.buttonMessageType = lockedMessage.messageType;
        buttonTextDetails.buttonText = 'Ja';
        buttonTextDetails.answerCode = 0;
        lockedMessage.showButtonText.push(buttonTextDetails);
        buttonTextDetails = new ButtonTextDetails();
        buttonTextDetails.buttonMessageType = lockedMessage.messageType;
        buttonTextDetails.environment = lockedMessage.environment;
        buttonTextDetails.answerCode = 1;
        buttonTextDetails.buttonText = 'Nein';
        lockedMessage.showButtonText.push(buttonTextDetails);
      } else if (lockedMessage.messageType == 3) {
        buttonTextDetails.buttonMessageType = lockedMessage.messageType;
        buttonTextDetails.buttonText = 'Ja';
        buttonTextDetails.answerCode = 0;
        lockedMessage.showButtonText.push(buttonTextDetails);
        buttonTextDetails.buttonText = 'Nein';
        buttonTextDetails.answerCode = 1;
        lockedMessage.showButtonText.push(buttonTextDetails);
        buttonTextDetails.answerCode = 2;
        buttonTextDetails.buttonText = 'Abbrechen';
        lockedMessage.showButtonText.push(buttonTextDetails);
      } else if (lockedMessage.messageType == 6) {
        buttonTextDetails.buttonMessageType = lockedMessage.messageType;
        buttonTextDetails.answerCode = 2;
        buttonTextDetails.buttonText = 'Abbrechen';
        lockedMessage.showButtonText.push(buttonTextDetails);
      }
    }
    return lockedMessage;
  }

  }
